import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover'
import { HexColorPicker } from 'react-colorful'

import { Button } from './button'

export function ColorPicker({
  color,
  onChange,
}: {
  color: string | undefined
  onChange: (value: string) => void
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" style={{ backgroundColor: color ?? 'transparent' }}>
          &nbsp;
        </Button>
      </PopoverTrigger>
      <PopoverContent className="z-20">
        <div>
          <HexColorPicker color={color} onChange={onChange} />
        </div>
      </PopoverContent>
    </Popover>
  )
}
